import { render, staticRenderFns } from "./BiometricsReport.vue?vue&type=template&id=ad5f3f3a&"
import script from "./BiometricsReport.vue?vue&type=script&lang=js&"
export * from "./BiometricsReport.vue?vue&type=script&lang=js&"
import style0 from "./BiometricsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BiometricsReport.vue"
export default component.exports